import React from 'react';
import {observer} from "mobx-react";

export const AICartButton = observer(({userRoles, business, onMenuClose, onPromptClick}) => {
    if (!userRoles.includes(business.marketplace_general_administrator_role()) &&
        !userRoles.includes(business.marketplace_operational_role())) {
        return null;
    }

    const handlePromptButtonClick = () => {
        if (onMenuClose) {
            onMenuClose();
        }
        if (onPromptClick) {
            onPromptClick();
        }
    };

    const buttonStyle = onMenuClose 
        ? {color: '#c1a17d', fontWeight: 'bold', paddingLeft: 0}
        : {color: '#c1a17d', fontWeight: 'bold', padding: 0};
    
    const liStyle = onMenuClose 
        ? {}
        : {
            display: "flex", 
            alignItems: "center",
            justifyContent: "center",
            position: "relative", 
            zIndex: 2,
            whiteSpace: "nowrap",
            listStyle: "none",
            margin: 0,
            padding: 0,
            height: "100%"
        };

    return (
        <li style={liStyle}>
            <button
                type="button"
                className="btn btn-link"
                style={{
                    ...buttonStyle,
                    padding: "8px 12px",
                    borderRadius: "8px",
                    transition: "all 0.3s ease",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    minHeight: "40px"
                }}
                onClick={handlePromptButtonClick}
                onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "rgba(193, 161, 125, 0.1)";
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                }}
                title="Armar carrito con IA"
            >
                <span
                    className="material-symbols-outlined"
                    style={{
                        fontVariationSettings: "'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24",
                        color: '#c1a17d',
                        fontSize: "28px",
                        display: "block"
                    }}
                >
                    smart_toy
                </span>
            </button>
        </li>
    );
});

